import { render, staticRenderFns } from "./userReport.vue?vue&type=template&id=2f0f22a4"
import script from "./userReport.vue?vue&type=script&lang=js"
export * from "./userReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports